import { createContext, type Dispatch, type SetStateAction } from 'react'

import { type getSubstantiationsQueryKey, type SubstantiationsFilters } from 'components/hooks/substantiations/useGetSubstantiations'

export type SubstantiationContextType = {
  setFilters: Dispatch<SetStateAction<SubstantiationsFilters>>
  getSubstantiationsQueryKey: ReturnType<typeof getSubstantiationsQueryKey>
}

const SubstantiationContext = createContext<SubstantiationContextType>({
  setFilters: () => { },
  getSubstantiationsQueryKey: [],
})

export default SubstantiationContext
